export default __webpack_public_path__ + "static/media/atb.77fdc30f.png";